import { Route, Routes } from "react-router-dom";
import { Box, CssBaseline, ThemeProvider } from "@mui/material";

import { theme } from "./theme/theme";

import { ClassesPage } from "./pages/classes";
import { HomePage } from "./pages/home";
import { ContactPage } from "./pages/contact";
import { CoachesPage } from "./pages/coaches";
import { NavBar } from "./components/layout/navbar";
import { Footer } from "./components/layout/footer";
import { GaleriePage } from "./pages/galerie";
import { NotFoundPage } from "./pages/not-found";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        <NavBar />
        <Box component="main" sx={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/cours" element={<ClassesPage />} />
            <Route path="/instructeurs" element={<CoachesPage />} />
            <Route path="/galerie" element={<GaleriePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Box>
        <Footer />
      </Box>
    </ThemeProvider>
  );
}

export default App;
